import { SkillTagsField } from "./SkillTagsField";

type Props = {
  value: string[];
  onChange: (next: string[]) => void;
  suggestions?: string[];
  disabled?: boolean;
  required?: boolean;
  error?: React.ReactNode;
  description?: string;
  size?: string;
};

export function LanguageTagsField({
  value,
  onChange,
  suggestions = [],
  disabled,
  required,
  error,
  description = "Spoken languages from the catalog, or type a custom one",
  size,
}: Props) {
  return (
    <SkillTagsField
      label="Languages"
      description={description}
      placeholder="e.g. English, Hindi, Tamil"
      value={value}
      onChange={onChange}
      suggestions={suggestions}
      disabled={disabled}
      required={required}
      error={error}
      maxTags={20}
      size={size}
    />
  );
}
